import * as Pages from '@/pages'

export const RoutesNames = {
  ROOT: '/',
  FEEDBACK_ERROR: '/feedback-error',
  FEEDBACK_AGE_RESTRICTION: '/feedback-age-restriction',
  HOME_CREDIT: '/onboarding',
}
export default [
  { path: RoutesNames.ROOT, component: Pages.Main },
  { path: RoutesNames.FEEDBACK_ERROR, component: Pages.FeedbackError },
  { path: RoutesNames.FEEDBACK_AGE_RESTRICTION, component: Pages.FeedbackAgeRestriction },
  { path: RoutesNames.HOME_CREDIT, component: Pages.HomeCredit },
]
